import './LoadingIndicatorCircular.css';

const STROKE_WIDTH = 15;
export function LoadingIndicatorCircular({
    intermediate = true,
    progress,
    className,
    size
}: {
    intermediate?: boolean;
    progress?: number;
    className?: string;
    size?: string;
}) {
    const radius = (100 - 15) / 2;
    const circumference = 2 * Math.PI * radius;
    const offset = circumference - (Math.max(Math.min(progress ?? 0, 100), 0) / 100) * circumference;
    return (
        <div style={{ width: size || '2rem', height: size || '2rem' }} className={className}>
            {intermediate && (
                <svg viewBox="0, 0, 100, 100">
                    <circle className="spinner-indeterminate-background" cx="50%" cy="50%" r="42"></circle>

                    <circle
                        strokeWidth="1.2rem"
                        className="spinner-indeterminate-indicator"
                        stroke="var(--fe-primary)"
                        fill="transparent"
                        cx="50%"
                        cy="50%"
                        r="42"></circle>
                </svg>
            )}
            {!intermediate && (
                <svg viewBox="0, 0, 100, 100" style={{ transform: 'rotate(-90deg)' }}>
                    <circle stroke-width={STROKE_WIDTH} fill="transparent" stroke="#ebeced" r="@_radius" cx="50" cy="50" />

                    <circle
                        strokeWidth={STROKE_WIDTH}
                        r={radius}
                        stroke="var(--fe-primary)"
                        strokeDasharray={circumference}
                        strokeDashoffset={offset}
                        fill="transparent"
                        cx="50"
                        cy="50"
                    />
                </svg>
            )}
        </div>
    );
}
